import Skeleton from './Skeleton';

// Skeleton de carregamento compartilhado pelos cards do dashboard.
// variant 'value' = título + valor (SaldoCard); 'list' = linhas (PorContaCard).
const CardSkeleton = ({ variant = 'value' }) => {
  if (variant === 'list') {
    return (
      <>
        <Skeleton width="100%" height={11} />
        <Skeleton width="100%" height={11} />
        <Skeleton width="100%" height={11} />
        <Skeleton width="80%" height={11} />
      </>
    );
  }
  return (
    <>
      <Skeleton width={130} height={26} style={{ marginBottom: 8 }} />
      <Skeleton width={90} height={11} />
    </>
  );
};

export default CardSkeleton;
